module.exports = __webpack_public_path__ + "media/images/story/typo/WelcomeGuest-db4984ece4f2d2bbfe07e0c0bb57d64a.svg";